import Dashboard from "views/Dashboard/Dashboard.jsx";
import GoogleMaps from "views/Maps/GoogleMaps.jsx";
import FullScreenMap from "views/Maps/FullScreenMap.jsx";
import VectorMap from "views/Maps/VectorMap.jsx";
import UserProfile from "views/Pages/UserProfile.jsx";
import MarketPlace from "views/Pages/UserProfile.jsx";
import Portal from "views/Portal/PortalOl.js";
import Notification from "views/Notification/Notification.js";
import Fansques from "views/Fansques/Fansques.js";
import Termcondition from "views/Termcondition/Termcondition.js";
import Company from "views/Company/Company.js";
import Users from "views/Users/Users.js";
import Peoples from "views/People/People.js";
import Alerts from "views/Alert/index.js";
import FileUpload from "views/FileUploads/index.js";
import Questionnaire from "views/Questionnaire/index.js";
import Marketplace from "views/Marketplace/marketplace.js";
import Statistic from "views/Userstatistic/Userstatistic.js";
import Masterdata from "views/Masterdata/Masterdata.js";
import Cctv from "views/Cctv/Cctv.js";
import CctvReport from "views/Cctv/cctvReport.js";
import CctvHistori from "views/Cctv/cctvHistori.js";
import LogActivity from "views/LogActivity/LogActivity.js";
import Monitoring from "views/Monitoring/Monitoring.js";
import Reporting from "../views/Reporting/Reporting";
import EmailMandatory from '../views/EmailMandatory/index.js'

import Search from "views/Search/Search.js";

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import AccountBox from "@material-ui/icons/AccountBox";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Work from "@material-ui/icons/Work";
import Shop from "@material-ui/icons/Shop";
import Place from "@material-ui/icons/Place";
import Notif from "@material-ui/icons/Warning";
import Faq from "@material-ui/icons/Help";
import Term from "@material-ui/icons/Announcement";
import People from "@material-ui/icons/People";
import Errors from "@material-ui/icons/Error";
import CloudUpload from "@material-ui/icons/CloudUpload";
import Email from "@material-ui/icons/Email";
import ShowChart from "@material-ui/icons/ShowChart";
import Wdetail from "@material-ui/icons/MultilineChart";
import AddComment from "@material-ui/icons/AddComment";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import Settings from "@material-ui/icons/Settings";


let dashRoutes;
dashRoutes = [
  {
    path: "/portal",
    name: "Portal",
    short: "Map",
    mini: "Map",
    icon: Place,
    component: Portal
  },
  {
    path: "/masterdata",
    name: "Masterdata",
    short: "Masterdata",
    mini: "Masterdata",
    icon: CloudUpload,
    component: Masterdata
  },
  // {
  //   path: "/statistic",
  //   name: " Usage Statistic",
  //   short: "Statistic",
  //   mini: "Statistic",
  //   icon: CloudUpload,
  //   component: Statistic
  // },
  {
    path: "/reporting",
    name: "Reporting",
    short: "Reporting",
    mini: "Reporting",
    component: Reporting
  },
  {
    path: "/components",
    name: "Monitoring",
    short: "Monitoring",
    mini: "Monitoring",
    component: Monitoring
  },
  {
    cctv: true,
    path: "/cctv",
    name: "CCTV",
    short: "CCTV",
    mini: "CCTV",
    state: "openComponents",
    icon: Settings,
    views: [
      {
        path: "/cctv-video",
        name: "CCTV",
        short: "CCTV",
        mini: "CCTV",
        icon: Notif,
        component: Cctv
      },
      {
        path: "/cctv-report",
        name: "CCTV Report",
        short: "Cctv-Report",
        mini: "Cctv-Report",
        icon: Errors,
        component: CctvReport
      },
      {
        path: "/cctv-history",
        name: "CCTV History",
        short: "Cctv-History",
        mini: "Cctv-History",
        icon: Errors,
        component: CctvHistori
      }
    ]
  },
  {
    collapse: true,
    path: "/components",
    name: "Settings",
    short: "Settings",
    mini: "Settings",
    state: "openComponents",
    icon: Settings,
    views: [
      /*{
        path: "/notification",
        name: "Notification",
        short: "Notification",
        mini: "Notification",
        icon: Notif,
        component: Notification
      },*/
      {
        path: "/alert",
        name: "Alert",
        short: "Alert",
        mini: "Alert",
        icon: Errors,
        component: Alerts
      },
      {
        path: "/email-mandatory",
        name: "Email Mandatory",
        short: "Email",
        mini: "Email",
        icon: Email,
        component: EmailMandatory
      },
      /*{
        path: "/termcondition",
        name: "Term and Condition",
        short: "Term and Condition",
        mini: "Term and Condition",
        icon: Term,
        component: Termcondition
      },
      {
        path: "/faq",
        name: "FAQ",
        short: "FAQ",
        mini: "FAQ",
        icon: Faq,
        component: Fansques
      },*/
      {
        path: "/file-upload",
        name: "File Upload",
        short: "File Upload",
        mini: "File Upload",
        icon: CloudUpload,
        component: FileUpload
      },
      {
        path: "/myuser",
        name: "User",
        short: "User",
        mini: "User",
        icon: AccountBox,
        component: UserProfile
      },

      {
        path: "/users",
        name: "Users",
        short: "Users",
        mini: "Users",
        icon: AccountBox,
        component: Users
      },

      {
        path: "/company",
        name: "User Group",
        short: "User Group",
        mini: "User Group",
        icon: Work,
        component: Company
      },
      // {
      //   path: "/questionnaire",
      //   name: "Questionnaire",
      //   short: "Questionnaire",
      //   mini: "Questionnaire",
      //   icon: CloudUpload,
      //   component: Questionnaire
      // },
      {
        path: "/logactivity",
        name: "Log Activity",
        short: "Log Activity",
        mini: "Log Activity",
        icon: CloudUpload,
        component: LogActivity
      }
    ]
  },

  /*{
    search: true,
    path: "/search",
    name: "Search",
    short: "Search",
    mini: "Search",
    component: Search
  },*/

  { redirect: true, path: "/", pathTo: "/pages/login", name: "Login" }
];
export default dashRoutes;
